'use es6';

import PropTypes from 'prop-types';
import { Children, Component } from 'react';
import { LEFT, RIGHT, UP, DOWN } from 'UIComponents/constants/KeyCodes';
import getPDFPageState from '../../selectors/getPDFPageState';
export default class PDFKeyControls extends Component {
  constructor(...args) {
    super(...args);

    this.handleKeydown = e => {
      const {
        onPage,
        pageIndex
      } = this.props;
      const {
        previousPageDisabled,
        nextPageDisabled
      } = getPDFPageState(this.props);

      switch (e.which) {
        case UP:
        case LEFT:
          if (previousPageDisabled) {
            return;
          }

          onPage(pageIndex - 1);
          return;

        case DOWN:
        case RIGHT:
          if (nextPageDisabled) {
            return;
          }

          onPage(pageIndex + 1);
          return;

        default:
          return;
      }
    };
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeydown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeydown);
  }

  render() {
    return Children.only(this.props.children);
  }

}
PDFKeyControls.propTypes = {
  children: PropTypes.any,
  onPage: PropTypes.func.isRequired,
  pageIndex: PropTypes.number.isRequired
};